import styled from 'styled-components';
import { Loading } from '@whitelabel/component-library';

const StyledLoading = styled(Loading)`
  width: 100vw;
  height: 100vh;
`;

export default StyledLoading;
